import type { ApsViewable } from "../stores/accModelStore";

/** Map ontology classes to APS viewable guids for violation sheet routing. */
export function liveSheetByOntologyType(
  viewables: ApsViewable[]
): Record<string, string> {
  const floor2d =
    viewables.find(
      v => v.kind === "2d" && /a2|floor\s*plan|floor plan/i.test(v.name)
    ) ?? viewables.find(v => v.kind === "2d");
  const model3d = viewables.find(v => v.kind === "3d");
  const floorId = floor2d?.id ?? "";
  const modelId = model3d?.id ?? floorId;
  return {
    "vera:Door": floorId,
    "vera:Opening": floorId,
    // Property-based room rules (glazing %, ceiling height) — show on floor plan.
    "vera:Room": floorId,
    "vera:Stair": modelId,
    "vera:Handrail": modelId,
    "vera:Guard": modelId,
    "vera:AccessibleWaterCloset": modelId,
  };
}
